<div class="wrapper flex vcenter">
  <mat-icon>language</mat-icon>
  <button
    mat-flat-button
    [matMenuTriggerFor]="menu"
  >
    {{ languageList[currentLang]?.label }}
    <mat-icon>arrow_drop_down</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    @for (lang of languageList | keyvalue; track lang.key) {
      <button
        mat-menu-item
        type="button"
        (click)="changeLanguage(lang.key)"
      >
        {{ lang.value.label }}
      </button>
    }
  </mat-menu>
</div>
